import React from 'react';
import { Stars } from '@zocdoc/components/src/stars';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';
import { FontFamily } from '@zocdoc/components/src/typography';

const RatingsContainer = styled.div`
    font: 13px/24px ${FontFamily.SharpSansBold};
    color: ${({ theme }) => theme.profile.textColor};
    display: flex;
    flex-direction: ${({ horizontal }) => horizontal ? 'row-reverse' : 'column'};
    justify-content: ${({ horizontal }) => horizontal ? 'flex-end' : 'flex-start'};

    ${breakpoint.medium} {
        font: 16px/24px ${FontFamily.SharpSansBold};
    }
`;

const StarsWrapper = styled.div`
    font-size: 12px;
    margin-bottom: 10px;
    margin-top: 0;

    ${breakpoint.medium} {
        font-size: 15.3px;
        margin-top: ${({ horizontal }) => horizontal ? 1 : 10}px;
    }
`;

const TextWrapper = styled.div`
    margin: ${({ horizontal }) => horizontal ? '0 1em 0 1em' : 0};
`;

const Rating = ({ name, rating, horizontal }) => (
    <RatingsContainer horizontal={horizontal}>
        <TextWrapper horizontal={horizontal}>
            {name}
        </TextWrapper>
        <StarsWrapper horizontal={horizontal}>
            <Stars rating={rating} />
        </StarsWrapper>
    </RatingsContainer>
);

export default Rating;
